export default __webpack_public_path__ + "static/media/explore-colored.4d195b2f.svg";